/* eslint-disable @typescript-eslint/naming-convention */
export enum ContentType {
  Accordion = 'accordion',
  ActionBanner = 'action_banner',
  AppFooterContent = 'app_footer_content',
  AppleTouchIcons = 'apple_touch_icons',
  Banner = 'banner',
  BonusGrid = 'bonus_grid',
  Box = 'box',
  BrandLogo = 'brand_logo',
  CTAGrid = 'cta_grid',
  Campaign = 'campaign',
  Carousel = 'carousel',
  CasinoCompletedRaces = 'casino_completed_races',
  CasinoGameDeck = 'casino_game_deck',
  CasinoGameGrid = 'casino_game_grid',
  CasinoGameInfo = 'casino_game_info',
  CasinoGameInfoDescription = 'casino_game_info_description',
  CasinoGameOfTheWeek = 'casino_game_of_the_week',
  CasinoGameSlider = 'casino_game_slider',
  CasinoGameTrailer = 'casino_game_trailer',
  CasinoGamesList = 'casino_games_list',
  CasinoJackpot = 'casino_jackpot',
  CasinoMosaic = 'casino_mosaic',
  CasinoMyGames = 'casino_my_games',
  CasinoMyRewards = 'casino_my_rewards',
  CasinoNewGames = 'casino_new_games',
  CasinoPlayerGames = 'casino_player_games',
  CasinoRaces = 'casino_races',
  CasinoSearchParameters = 'casino_search_parameters',
  CasinoSecondaryNavigation = 'casino_secondary_navigation',
  CasinoTopGames = 'casino_top_games',
  CategoryHighlight = 'category_highlight',
  ContentArea = 'content_area',
  ContentCard = 'content_card',
  Crm = 'crm',
  DetailsGrid = 'details_grid',
  EntrySearchReference = 'entry_search_reference',
  EventSchedule = 'event_schedule',
  EventTournament = 'event_tournament',
  FAQ = 'faq',
  FirstWallet = 'first_wallet',
  Form = 'form',
  GeoRedirect = 'geo_redirect',
  Glossary = 'glossary',
  Grid = 'grid',
  HeaderLink = 'header_link',
  HelpBot = 'help_bot',
  HelpCenterArticle = 'help_center_article',
  HelpCenterCategory = 'help_center_category',
  HelpCenterHome = 'help_center_home',
  HelpCenterSearch = 'help_center_search',
  Highlight = 'highlight',
  IspConfig = 'isp_config',
  IconsGrid = 'icons_grid',
  LeaderBoard = 'leader_board',
  LegacySports = 'legacy_sports',
  LinkedImageList = 'linked_image_list',
  Language = 'language',
  Main = 'main',
  MatchInfo = 'match_info',
  MediaGrid = 'media_grid',
  Menu = 'menu',
  Meta = 'meta',
  Page = 'page',
  Panel = 'panel',
  PaymentVendors = 'payment_vendors',
  Podcast = 'podcast',
  PokerBespokeLobby = 'poker_bespoke_lobby',
  PokerCgSimpleFilterVars = 'poker_cg_simple_filter_vars',
  PokerCashGames = 'poker_cash_games',
  PokerHomeGames = 'poker_home_games',
  PokerHowItWorksModal = 'poker_how_it_works_modal',
  PokerLobby = 'poker_lobby',
  PokerLobbyCTAEvent = 'poker_lobby_cta_event',
  PokerLobbyInfoItem = 'poker_lobby_info_item',
  PokerLobbyInfoItemV2 = 'poker_lobby_info_item_v2',
  PokerLobbyRelatedEvent = 'poker_lobby_related_event',
  PokerLobbyTemplate = 'poker_lobby_template',
  PokerMttQueryVariables = 'poker_mtt_query_variables',
  PokerMultiTableTournaments = 'poker_multi_table_tournaments',
  PokerPowerPath = 'poker_power_path',
  PokerRelatedEvents = 'poker_related_events',
  PokerSatellite = 'poker_satellite',
  PokerSingleTournament = 'poker_single_tournament',
  PokerSpinAndGo = 'poker_spin_and_go',
  PokerSundayMillion = 'poker_sunday_million',
  PokerTournamentNameColourVariables = 'poker_tournament_name_colour_variables',
  PowerPathMoreTab = 'power_path_more_tab',
  PowerPathOverviewTab = 'power_path_overview_tab',
  PromotionBanner = 'promotion_banner',
  ProspectHomepageSlide = 'prospect_homepage_slide',
  Redirect = 'redirect',
  ReferAFriend = 'refer_a_friend',
  RegulatoryFooter = 'regulatory_footer',
  RegulatoryHeader = 'regulatory_header',
  ReusableContent = 'reusable_content',
  SEO = 'seo',
  SEOFooter = 'seo_footer',
  Side = 'side',
  SideCTA = 'side_cta',
  SideRelatedContent = 'side_related_content',
  SideTwitter = 'side_twitter',
  SiteFooter = 'site_footer',
  SiteHeader = 'site_header',
  StickyFooter = 'sticky_footer',
  Tabs = 'tabs',
  Template = 'template',
  Terms = 'terms',
  TilesGrid = 'tiles_grid',
  Top = 'top',
  UploadHistory = 'upload_history',
  VideoPanel = 'video_panel',
  Website = 'website',
  WebsiteConfig = 'website_config',
  WebsiteLanguages = 'website_languages'
}

export interface BasicReference {
  uid: string;
  _content_type_uid: string;
}

export interface Reference extends BasicReference {
  _content_type_uid: ContentType;
}
